module.exports = __webpack_public_path__ + "img/projectImg.d8aaf991.png";